import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import NoDataFoundMex from "../ViewComponents/NoDataFound";
import FormatDateTime from "../../Functions/FormatDate";
import { useNavigate, useParams } from "react-router-dom";
import { IoOpenOutline } from "react-icons/io5";

const TableDeployments = ({ data, handleDeleteClick }) => {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const [sortedData, setSortedData] = useState(data || []);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [copiedId, setCopiedId] = useState(null);
    const no_data_mex = t.deployments.table.no_data
    const { project_id } = useParams()

    useEffect(() => {
        setSortedData(data);
    }, [data]);

    const headers = sortedData.length > 0
        ? Object.keys(sortedData[0]).filter(header => !["project_id", "pod_name", "namespace", "files", "container_info", "cron_jobs"].includes(header))
        : [];


    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }

        const sorted = [...sortedData].sort((a, b) => {
            const aValue = a[key] || "";
            const bValue = b[key] || "";

            return aValue < bValue ? (direction === "asc" ? -1 : 1) : aValue > bValue ? (direction === "asc" ? 1 : -1) : 0;
        });

        setSortedData(sorted);
        setSortConfig({ key, direction });
    };

    const handleIdClick = (id) => {
        navigator.clipboard.writeText(id).then(() => {
            setCopiedId(id);
            setTimeout(() => {
                setCopiedId(null);
            }, 3000);
        });
    };


    if (sortedData.length === 0) {
        return <NoDataFoundMex message={no_data_mex} />;
    }

    return (
        <div className="table-responsive fade-in">
            <table className="table">
                <thead>
                    <tr>
                        <th style={{ width: "40px" }}></th>
                        {headers.map((header) => (
                            <th
                                key={header}
                                onClick={() => handleSort(header)}
                                style={{ cursor: "pointer" }}
                                aria-sort={sortConfig.key === header ? (sortConfig.direction === "asc" ? "ascending" : "descending") : "none"}
                                className={sortConfig.key === header ? "active-sort" : ""}
                            >
                                {/* {t.access.table[header]} */}
                                {t.deployments.table[header]}
                                {sortConfig.key === header ? (
                                    sortConfig.direction === "asc" ? (
                                        <i className="fa-solid fa-arrow-up"></i>
                                    ) : (
                                        <i className="fa-solid fa-arrow-down"></i>
                                    )
                                ) : null}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((row, rowIndex) => (
                        <tr key={rowIndex} >
                            <td className={`${row._id == "default" ? "default_row" : ""}`}>
                                <Dropdown>
                                    <div className="property_btn_action_toggle">
                                        <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="custom-dropdown-menu">

                                            {row._id != "default" && (
                                                <Dropdown.Item className="drop_down_item delete" onClick={() => handleDeleteClick(row._id, "deleted")}>
                                                    <i className="fa-solid fa-trash"></i> {t.delete}
                                                </Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </div>
                                </Dropdown>
                            </td>
                            {headers.map((header) => {
                                let cellData = "";

                                cellData = row[header];


                                return (
                                    <td
                                        key={`${rowIndex}-${header}`}
                                        onClick={header === "_id" ? () => handleIdClick(cellData) : undefined}
                                        className={`${row._id === "default" ? "default_row" : ""}`}
                                    >
                                        <div className={copiedId === row._id ? "copied_item" : ""} title={typeof cellData === "string" ? cellData : undefined}>
                                            {header === "_id" ? (
                                                <div className="clickable_id_cell" onClick={() => navigate(`/project_panel/${project_id}/deployments/${row._id}/logs`)}>
                                                    {cellData} <i><IoOpenOutline/></i>
                                                </div>
                                            ) : header === "timestamp" ? (
                                                FormatDateTime(cellData)
                                            ) : header === "deployment_name" ? (
                                                cellData
                                            ) : header === "schedule" ? (
                                                <p>
                                                    {cellData
                                                        ? (() => {
                                                            const [minute, hour] = cellData.split(" ");
                                                            return `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
                                                        })()
                                                        : "Single run"}
                                                </p>
                                            ) : header === "status" ? (
                                                <p
                                                    className={
                                                        row.status === "scheduled"
                                                            ? "log_item_success"
                                                            : row.container_info && row.container_info.pod
                                                                ? row.container_info.pod.phase === "Running"
                                                                    ? "log_item_success"
                                                                    : row.container_info.pod.phase === "Failed"
                                                                        ? "log_item_failed"
                                                                        : "log_item_loading"
                                                                : "updating"
                                                    }
                                                >
                                                    {row.status === "scheduled"
                                                        ? "Scheduled"
                                                        : row.container_info
                                                            ? row.container_info.pod
                                                                ? row.container_info.pod.phase
                                                                : row.container_info.phase || "Loading status..."
                                                            : "Loading status..."}
                                                </p>
                                            )

                                                : typeof cellData === "object" && cellData !== null ? (
                                                    <pre style={{ margin: 0 }}>{JSON.stringify(cellData, null, 2)}</pre>
                                                ) : (
                                                    cellData
                                                )}
                                        </div>
                                    </td>

                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableDeployments;
